/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Status of summary computation
 * @export
 * @enum {string}
 */
export type SummaryStatus =
  'SUCCESS' | 
  'FAILURE'


export function SummaryStatusFromJSON(json: any): SummaryStatus {
    return SummaryStatusFromJSONTyped(json, false);
}

export function SummaryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryStatus {
    return json as SummaryStatus;
}

export function SummaryStatusToJSON(value?: SummaryStatus | null): any {
    return value as any;
}

